import { useState } from 'react'
import { useAddSuppression } from '@/api/hooks/use-suppressions'
import { Modal } from '@/components/ui/modal'

interface AddSuppressionModalProps {
  onClose: () => void
}

const REASON_OPTIONS = [
  { value: 'manual', label: 'Manual' },
  { value: 'hard_bounce', label: 'Hard Bounce' },
  { value: 'complaint', label: 'Complaint' },
] as const

export function AddSuppressionModal({ onClose }: AddSuppressionModalProps): React.JSX.Element {
  const addSuppression = useAddSuppression()
  const [email, setEmail] = useState('')
  const [reason, setReason] = useState('manual')

  function handleSubmit(e: React.FormEvent): void {
    e.preventDefault()
    addSuppression.mutate({ email_address: email, reason }, { onSuccess: onClose })
  }

  return (
    <Modal open onClose={onClose} title="Add Suppression">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="suppression-email"
            className="block text-sm font-medium text-text-primary"
          >
            Email Address
          </label>
          <input
            id="suppression-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="user@example.com"
            className="mt-1 w-full rounded-lg border border-surface-3 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none"
          />
        </div>

        <div>
          <label
            htmlFor="suppression-reason"
            className="block text-sm font-medium text-text-primary"
          >
            Reason
          </label>
          <select
            id="suppression-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="mt-1 w-full rounded-lg border border-surface-3 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none"
          >
            {REASON_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-end gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-surface-3 px-4 py-2 text-sm hover:bg-surface-1"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={!email.trim() || addSuppression.isPending}
            className="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50"
          >
            {addSuppression.isPending ? 'Adding...' : 'Add to Suppression List'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
